export const staffManagementTimeLeaveArticle = {
  title: 'Staff Management: Time, Leave & Coverage',
  slug: 'staff-management-time-leave',
  content: `Staff Management: Time, Leave & Coverage

Manage schedules, time tracking, and holidays.

1) Time Clock
- Track clock-ins and time activity.

2) Work Rota
- Review weekly schedules and shift coverage.
- Export or adjust schedules as needed.

3) Holidays
- Submit leave requests and approve/reject requests.

4) Payroll Prep
- Review payroll prep data before processing.

5) Coverage
- Review coverage gaps by day and shift.
`,
};
